import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { MagnifyingGlass, Pencil, GearSix } from "@phosphor-icons/react";
import { toast } from "react-toastify";
import axios from "axios";
import { BaseUrl } from "../../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import {} from "../../../Redux/Actions/actions";
import { Avatar, Box, Button, Chip, Grid, Stack } from "@mui/material";
import CustomerDetailSearchNew from "./Customer-Detail-Search/Customer-Detail-Search-New";
import EditUser from "./EditUser-Component/EditUser";
import { toaststyle } from "../../../Utils/toaststyle";
import { MdEmail } from "react-icons/md";
import { FaMobile } from "react-icons/fa";
const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};

const UserDetails = (props) => {
  const [editUserModal, setEditUserModal] = useState(false);
  const [CustomerDetailSearch, setCustomerDetailSearch] = useState(false);
  const [Numbercopyed, setNumbercopyed] = useState("Copy");

  const updateEditvalueModel = () => {
    setEditUserModal(!editUserModal);
  };

  const CrmScreenpopupApi = async () => {
    let body;
    if (
      props.externalChatData
        ? props.externalChatData.channel == "voice" &&
          (localStorage.getItem("type") === "sales" ||
            localStorage.getItem("type") === "service")
        : ""
    ) {
      body = {
        phonenumber: props.externalChatData.phonenumber,
        skillset: props.externalChatData.skillset,
        channel: props.externalChatData.channel,
        type: localStorage.getItem("type"),
        reg_no: localStorage.getItem("Contactreg_no"),
        contact_id: localStorage.getItem("ContactVoiceId"),
      };
    } else {
      body = {
        phonenumber: props.externalChatData.phonenumber,
        skillset: props.externalChatData.skillset,
        channel: props.externalChatData.channel,
        direction:props.externalChatData.direction=="Inbound"?"INBOUND":"OUTBOUND",
      contactid:props.externalChatData.voice_contactId?props.externalChatData.voice_contactId:"",
      };
    }
    await axios
      .post(BaseUrl + "/ticket/crmscreenpop", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        toast.success("screen pop url generated", toaststyle);

        setTimeout(() => {
          window.open(res.data.data);
        }, 2000);
      })
      .catch((error) => {
        console.log("error", error);
        toast.warning("screen pop url not generated", toaststyle);
      });
  };

  const handleOpenCrmUrl = () => {
    const randomNumber =
      Math.floor(Math.random() * (10000000 - 9999999 + 1)) + 9999999;
    const url = `https://inaipi.ae/v2/screenpopup?number=${
      props.externalChatData ? props.externalChatData.phonenumber : ""
    }&skillset=${
      props.externalChatData ? props.externalChatData.skillset : ""
    }&callid=${randomNumber}&survey_opt=1&type=${
      props.externalChatData ? props.externalChatData.channel : ""
    }&direction=INBOUND`;
    window.open(url, "_blank");
  };

  return (
    <>
      <Box
        sx={{
          height: "100%",
          width: "100%",
        }}
      >
        <Grid container spacing={2}>
          <Grid
            item
            xs={3}
            className="h-100 d-flex align-items-center justify-content-start position-relative"
          >
            {/* user Avatar  */}
            <Avatar
              style={{
                width: "60px",
                height: "60px",
                background: "#2757a5",
                fontSize: "20px",
              }}
              className="box-inset2 mt-2"
            >
              {props.externalChatData
                ? props.externalChatData.unique_id
                  ? props.externalChatData.unique_id.username
                    ? props.externalChatData.unique_id.username
                        .slice(0, 2)
                        .toUpperCase()
                    : props.externalChatData.unique_id.phonenumber
                        .slice(0, 2)
                        .toUpperCase()
                  : ""
                : ""}
            </Avatar>
            {/* user status /  */}
            <Box>
              <Stack direction={"row"} justifyContent={"end"}>
                {props.externalChatData ? (
                  props.externalChatData.unique_id ? (
                    props.externalChatData.unique_id.isvip ? (
                      <span className="badge badge-pill bg-primary fs-10 user-vip">
                        VIP
                      </span>
                    ) : (
                      <span className="badge badge-pill bg-primary fs-10 user-normal">
                        Normal
                      </span>
                    )
                  ) : null
                ) : null}
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={9} className="mb-3">
            {/* user name */}
            <div className="w-100 d-flex mt-2">
              <strong
                className="mx-1 text-truncate w-75"
                style={{ fontSize: "17px", color: "#0b3363" }}
              >
                {props.externalChatData
                  ? props.externalChatData.unique_id
                    ? props.externalChatData.unique_id.username
                      ? props.externalChatData.unique_id.username
                      : "none"
                    : ""
                  : ""}
              </strong>
            </div>
            {/* user email  */}
            <div className="w-100 d-flex">
              <div className="w-100 d-flex align-items-center justify-content-start">
                <MdEmail
                  className="me-2"
                  size={13}
                  style={{
                    color: "#2757a5",
                  }}
                />
                <p
                  className="pb-0 mb-0 text-truncate w-75 textp"
                  style={{ fontSize: "12px" }}
                >
                  {props.externalChatData
                    ? props.externalChatData.unique_id
                      ? props.externalChatData.unique_id.email
                        ? props.externalChatData.unique_id.email
                        : "none"
                      : ""
                    : ""}
                </p>
              </div>
            </div>
            {/* user mobile  */}
            <div className="w-100 d-flex">
              <div className="w-100 d-flex align-items-center justify-content-start">
                <FaMobile
                  className="me-2"
                  size={13}
                  style={{
                    color: "#2757a5",
                  }}
                />
                <p
                  className="pb-0 mb-0 text-truncate w-75 textp"
                  style={{ fontSize: "12px" }}
                >
                  <Tooltip title={Numbercopyed} arrow placement="right">
                    <span
                      className="w-100 text-break"
                      onClick={() => {
                        navigator.clipboard.writeText(props.selectedmobile);
                        setNumbercopyed("Copied");
                        setTimeout(() => {
                          setNumbercopyed("Copy");
                        }, 3000);
                      }}
                      style={{ cursor: "pointer", fontSize: "12px" }}
                    >
                      {props.externalChatData
                        ? props.externalChatData.unique_id
                          ? props.externalChatData.unique_id.phonenumber
                            ? props.externalChatData.unique_id.phonenumber
                            : "none"
                          : ""
                        : ""}
                    </span>
                  </Tooltip>
                </p>
              </div>
            </div>
          </Grid>
        </Grid>
        {/* btns control  */}
        <Box className="btn-groups">
          <Stack
            direction={"row"}
            alignItems={"center"}
            spacing={0.5}
            justifyContent={"between"}
          >
            <Tooltip title={"Edit"} arrow placement="top">
              <Box
                sx={{
                  width: "25px",
                  height: "25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  cursor: "pointer",
                  transition: "background-color 0.5s, color 0.5s, fill 0.5s",
                  "&:hover": {
                    background: "#595858e8",
                    color: "white",
                  },
                }}
                onClick={() => {
                  updateEditvalueModel();
                }}
              >
                <Pencil size={14} cursor={"pointer"} weight="bold" />
              </Box>
            </Tooltip>

            <Tooltip title={"Customer Search"} arrow placement="top">
              <Box
                sx={{
                  width: "25px",
                  height: "25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  cursor: "pointer",
                  transition: "background-color 0.5s, color 0.5s, fill 0.5s",
                  "&:hover": {
                    background: "#595858e8",
                    color: "white",
                  },
                }}
                onClick={() => {
                  setCustomerDetailSearch(true);
                }}
              >
                <MagnifyingGlass size={14} cursor={"pointer"} weight="bold" />
              </Box>
            </Tooltip>

            {JSON.parse(localStorage.getItem("permission")).map(
              (module, index) => {
                if (module.moduleName === "Crm") {
                  const crmScreen = module.screen.find(
                    (item) => item.screenId === "CRM" && item.read && item.write
                  );

                  if (crmScreen) {
                    return (
                      <Tooltip key={index} title={"CRM"} arrow placement="top">
                        <Box
                          sx={{
                            width: "25px",
                            height: "25px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                            cursor: "pointer",
                            transition:
                              "background-color 0.5s, color 0.5s, fill 0.5s",
                            "&:hover": {
                              background: "#595858e8",
                              color: "white",
                            },
                          }}
                          onClick={() => {
                            CrmScreenpopupApi();
                          }}
                        >
                          <GearSix size={14} cursor={"pointer"} weight="bold" />
                        </Box>
                      </Tooltip>
                    );
                  } else {
                    return null;
                  }
                }
                return null;
              }
            )}
          </Stack>
        </Box>
      </Box>

      {editUserModal && (
        <EditUser
          OpenDialog={editUserModal}
          handleClose={() => {
            setEditUserModal(false);
          }}
        />
      )}
      {CustomerDetailSearch && (
        <CustomerDetailSearchNew
          OpenDialog={CustomerDetailSearch}
          handleClose={() => {
            setCustomerDetailSearch(false);
          }}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps, {})(UserDetails);
